import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=c5884726&scoped=true&"
import script from "./Historic.vue?vue&type=script&lang=js&"
export * from "./Historic.vue?vue&type=script&lang=js&"
import style0 from "./Historic.vue?vue&type=style&index=0&id=c5884726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5884726",
  null
  
)

export default component.exports